import { render } from "./App.vue?vue&type=template&id=292148ea&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=292148ea&scoped=true&lang=css"

import exportComponent from "D:\\phpstudy_pro\\data.yuandiansiyu.com\\platform_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-292148ea"]])

export default __exports__